/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {AuthService} from '../_services/auth.service';
import {LOGIN_PATH} from '../_enums/constants';

@Injectable()
export class AuthGuard implements CanActivate {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(public router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.currentUser && this.authService.getCurrentToken()) {
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.authService.returnUrl = state.url;
    this.router.navigate([LOGIN_PATH], {queryParams: {returnUrl: state.url}});
    return false;
  }

}
